export default __webpack_public_path__ + "static/media/Avatar.2b1fb730.svg";